module.exports = __webpack_public_path__ + "img/nt118-04-81-1.prt.f30995f9.jpg";